import { render } from "./designation.vue?vue&type=template&id=439a97bf&scoped=true"
import script from "./designation.js?vue&type=script&lang=js"
export * from "./designation.js?vue&type=script&lang=js"

import "./designation.vue?vue&type=style&index=0&id=439a97bf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439a97bf"]])

export default __exports__